/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Baloontwo({mode},props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Baloontwo.glb')
  const { actions, names } = useAnimations(animations, group)

  useEffect(() => {
    // Reset and fade in animation after an index has been changed
    
    actions[names].reset().fadeIn(0.5).play()
    actions[names].timeScale = 0.5
 
    // In the clean-up phase, fade it out
   
  }, [ actions, names])


  return (
    <group ref={group} {...props} dispose={null} position={[0,0,200]}>
      <group name="Scene">
        <group
          name="airbaloon_geo_two"
          position={[-421.118, 143.728, -297.414]}
          rotation={[3.136, 0.555, -3.124]}
          scale={0.025}>
          <mesh
            name="Mesh080"
            castShadow
            receiveShadow
            geometry={nodes.Mesh080.geometry}
            material={materials['rgp_tex.003']}
          >
             { mode === "night" && <pointLight castShadow={false} intensity={20000} color={'orange'} position={[-10,-10,-210]}/> }
            </mesh>
          <mesh
            name="Mesh080_1"
            castShadow
            receiveShadow
            geometry={nodes.Mesh080_1.geometry}
            material={materials['acochillcamp_tex.001']}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/Baloontwo.glb')
